var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoContactsArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 156,
    viewBox: "0 0 276 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5L0.811979 23.1132L22.7396 15.8665L5.5 0.5ZM274.769 150.013C240.045 154.057 186.316 151.966 135.398 133.223C84.5229 114.496 36.5829 79.2052 13.0211 16.8901L9.27962 18.3047C33.3563 81.9816 82.365 117.964 134.017 136.977C185.626 155.974 240.003 158.089 275.231 153.987L274.769 150.013Z",
    fill: "#2F7BF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContactsArrow);
export default __webpack_public_path__ + "static/media/no-contacts-arrow.0421eb2e4d2d701726ba7f92a5fc1d6f.svg";
export { ForwardRef as ReactComponent };